import { TransferContext } from '../TransferContext';
import { useContext } from 'react';

export const useTransferContext = () => {
  const context = useContext(TransferContext);

  return context;
};